import { ParentTypes } from '@risksmart-app/domain/src/types/consts';

import { t } from '../../i18n-t';
import { getAuditColumns } from './shared';
import type { SharedDataset } from './types';

export const getIndicatorResults = () =>
  ({
    supportedLatest: true,
    hasAccess: () => true,
    objectType: ParentTypes.IndicatorResult,
    label: 'Indicator results',
    customAttributeFormConfigurationParentTypes: [ParentTypes.IndicatorResult],
    fields: {
      id: {
        dataType: 'guid',
        displayType: 'text',
        defaultLabel: t('columns.guid'),
      },
      details: {
        dataType: 'text',
        displayType: 'text',
        formConfig: { formId: 'indicator_result', fieldId: 'Description' },
      },
      date: {
        dataType: 'date',
        displayType: 'date',
        formConfig: { formId: 'indicator_result', fieldId: 'ResultDate' },
      },
      numberValue: {
        dataType: 'number',
        displayType: 'number',
        // RSP-5439: disambiguate the two result attributes in the CDS attribute
        // selector. The dataset label resolves from `formLabel` (datasetModel.ts),
        // and both TargetValueNum/TargetValueTxt formLabels are "Result" — so an
        // explicit defaultLabel is required here to surface the type.
        defaultLabel: t('indicator_results.columns.result_number'),
      },
      textValue: {
        dataType: 'text',
        displayType: 'text',
        defaultLabel: t('indicator_results.columns.result_text'),
      },
      ...getAuditColumns(),
    },
  }) as const satisfies SharedDataset;
